

export default function checkServiceType(serviceType) {
 
    switch (serviceType) {
      case "Wash & Fold":
        return "WASH_N_FOLD";
      case "Dry Cleaning":
        return "DRYCLEANING";
      case "Tailoring":
        return "TAILORING";
      default:
        return "other_services";
    }
}